import { render } from "./CxMapInfoBox.vue?vue&type=template&id=55c13158&scoped=true"
import script from "./CxMapInfoBox.vue?vue&type=script&lang=js"
export * from "./CxMapInfoBox.vue?vue&type=script&lang=js"

import "./CxMapInfoBox.vue?vue&type=style&index=0&id=55c13158&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c13158"]])

export default __exports__